import { render } from "./DecoinsLimitModal.vue?vue&type=template&id=58a66c7a&scoped=true&ts=true"
import script from "./DecoinsLimitModal.vue?vue&type=script&lang=ts"
export * from "./DecoinsLimitModal.vue?vue&type=script&lang=ts"

import "./DecoinsLimitModal.vue?vue&type=style&index=0&id=58a66c7a&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a66c7a"]])

export default __exports__